"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractNoticeParams = void 0;
var lodash_1 = require("lodash");
var account_1 = require("../../account");
/** Параметры уведомления */
var AbstractNoticeParams = /** @class */function () {
  function AbstractNoticeParams() {
    /** Отметка времени */
    this.timestamp = Date.now();
    this.tenant = account_1.TenantEnum.onclass_com;
  }
  AbstractNoticeParams.createInstance = function (values) {
    var instance = new this();
    instance.applyValues(values);
    return instance;
  };
  AbstractNoticeParams.prototype.toString = function () {
    return "".concat(this.constructor.name, ".createInstance(").concat(JSON.stringify(this), ")");
  };
  AbstractNoticeParams.prototype.applyValues = function (values) {
    var instance = this;
    this.getClassDateProperties().map(function (p) {
      if (p in values) {
        var value = values[p];
        if (value) {
          values[p] = new Date(value);
        }
      }
    });
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, this.getClassProperties()));
  };
  AbstractNoticeParams.prototype.getClassProperties = function () {
    return ['id', 'type', 'timestamp'];
  };
  AbstractNoticeParams.prototype.getClassDateProperties = function () {
    return [];
  };
  return AbstractNoticeParams;
}();
exports.AbstractNoticeParams = AbstractNoticeParams;
